import { call, take, put, fork, all } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import { ChatActionTypes } from './type';
// import * as Sentry from "@sentry/browser";

function* fetch_consult_info() {
  while (true) {
    const action = yield take(ChatActionTypes.FETCH_CONSULT_INFO);
    try {

      const { data = {} } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/medical/consult/save',
        type: 'POST',
        data: {
          ...data,
          consultAdmissionsType: 'nurse',
        },
        isloading: true,
        action,
      });
      if (res && res.code === '0') {

        // isAllNurseBusy 匹配的医生团队护士繁忙状态时 给系统提示
        // isAllDoctorRest 绑定医生是开诊但是是下班状态 或者所有的医生状态都是休息状态，返回true 显示休息中
        // isNurseOnDuty 区分值班状态还是上班状态
        const { roomId = 0, id = 0, isAllNurseBusy, userHeadPortrait = '', isNurseOnDuty, status: consultStatus = '', isAllDoctorRest = '', consultNo = '', doctorAssistantView = {}, medicalStaffView = {}, thirdPatientInfoDomain = {}, needPushAddWechatCard = false, isVipChannel } = res.result;
        const { id: doctorId = '', staffName = '', headPortrait = '', firstPageHeadPortrait = '', staffNo = '', staffProfessionalTitle = '', certificateObtainTime = '', workSeniority } = medicalStaffView;
        const doctorInfo = {
          staffName,
          headPortrait,
          firstPageHeadPortrait,
          doctorId,
          staffNo,
          staffId:doctorId,
          staffProfessionalTitle,
          certificateObtainTime,
          workSeniority,
        };
        const { assistantName = '', id: assistantId = 0, highlightResume, gender } = doctorAssistantView;
        const assistantInfo = {
          assistantName,
          assistantId,
          highlightResume,
          gender,
        };
        const consultInfo = {
          isVipChannel,
          consultNo,
          isNurseOnDuty,
          isAllDoctorRest,
          needPushAddWechatCard,
          consultId: id,
          consultStatus,
          isAllNurseBusy,
        };

        yield put({
          type: ChatActionTypes.FETCH_CONSULT_INFO_SUCCESS, data: {
            doctorInfo,
            assistantInfo,
            roomId,
            consultInfo,
            userHeadPortrait,
            thirdPatientInfoDomain, // 蚂蚁渠道的患者信息
            historyTime: new Date().getTime(),
          },
        });

        if (consultStatus === '2') {
          continue;
        }

        const msg: any = [];
        // const isRealAuth: string = cookies.get('isRealAuth') || 'N';

        // 消息顺序：值班、主诉、欢迎语、实名卡、系统消息
        if (isAllDoctorRest === 'Y' || isNurseOnDuty === 'Y') {
          msg.push({
            msg_type: 6,
            reply_content: {
              mode: 'mobile',
            },
            isAllDoctorRest,
            isNurseOnDuty,
            appointRight: false,
            reqid: new Date().getTime(),
          });
        }

        if (isAllDoctorRest === 'Y') {
          yield put({
            type: ChatActionTypes.SHIFT_CHAT_MSG, data: msg,
          });
        }
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}


// 通过咨询单编号查咨询单详情
function* fetch_consult_detail() {
  while (true) {
    const action = yield take(ChatActionTypes.FETCH_CONSULT_DETAIL);
    try {
      const { data } = action;
      const res = yield call(fetchJson, {
        type: 'POST',
        url: '/api/api/v1/patient/medical/consult/detail',
        data,
        isloading: true,
      });
      if (res && res.code === '0') {
        yield put({ type: ChatActionTypes.FETCH_CONSULT_DETAIL_SUCCESS, data: res.result || {} });
      }
    } catch (error) {
      // Sentry.captureException(error);
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* update_consult_info() {
  while (true) {
    const action = yield take(ChatActionTypes.UPDATE_CONSULT_INFO);
    try {
      const { data = {} } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/medical/consult/save',
        type: 'POST',
        data,
        isloading: false,
        action,
      });
      if (res && res.code === '0') {
      }
    } catch (error) {
      // Sentry.captureException(error);
    }
  }
}

export default function* root() {
  yield all([
    fork(fetch_consult_info),
    fork(fetch_consult_detail),
    fork(update_consult_info),
  ]);
}
